var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4259 9.24019L0.621176 0.814745C0.552873 0.780593 0.474525 0.772558 0.400194 0.790638C0.317698 0.811032 0.246645 0.863284 0.202592 0.935953C0.158538 1.00862 0.145075 1.09579 0.16515 1.17836L1.89685 8.25381C1.92296 8.36028 2.00131 8.44666 2.10577 8.48082L5.07296 9.49934L2.10778 10.5179C2.00332 10.554 1.92497 10.6384 1.90086 10.7449L0.16515 17.8304C0.147069 17.9047 0.155105 17.983 0.189257 18.0493C0.267605 18.208 0.460462 18.2723 0.621176 18.194L17.4259 9.81675C17.4881 9.78662 17.5384 9.73439 17.5705 9.67412C17.6489 9.51341 17.5846 9.32055 17.4259 9.24019ZM2.14595 15.8174L3.15644 11.6871L9.0868 9.65202C9.13301 9.63595 9.17118 9.59979 9.18725 9.55158C9.21537 9.4672 9.17118 9.3768 9.0868 9.34666L3.15644 7.31363L2.14997 3.19934L14.766 9.52546L2.14595 15.8174Z",
    fill: "url(#paint0_linear_2682_28015)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2682_28015",
    x1: 0.155762,
    y1: 0.78125,
    x2: 17.6019,
    y2: 18.2293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#E36D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A841"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.8dfbbd2e71ee7188a1f287044a2680e5.svg";
export { ForwardRef as ReactComponent };